/**
 * Normalize any API error response into a human-readable string.
 * Handles FastAPI 422 detail arrays, string details, nested objects, and unknown shapes.
 */
export function normalizeApiError(err) {
  if (!err) return 'An unexpected error occurred.';
  if (typeof err === 'string') return err;

  // FastAPI 422: { detail: [{msg, loc, type}, ...] }
  if (Array.isArray(err)) {
    const msgs = err
      .map((item) => (typeof item === 'string' ? item : item?.msg || ''))
      .filter(Boolean);
    return msgs.length > 0 ? msgs.join(', ') : 'Validation error.';
  }

  if (typeof err === 'object') {
    const detail = err.detail;

    if (detail !== undefined) {
      if (typeof detail === 'string') return detail;
      if (Array.isArray(detail)) return normalizeApiError(detail);
      try { return JSON.stringify(detail); } catch { return 'Unknown error.'; }
    }

    if (typeof err.msg === 'string') return err.msg;
    if (typeof err.message === 'string') return err.message;

    try { return JSON.stringify(err); } catch { return 'Unknown error.'; }
  }

  return String(err);
}

export default normalizeApiError;
